<template>
    <div class="backpage" @click="goBack">

        ← 返回上一级
    </div>
    <div class="installt">
        <div class="intext">提现审核</div>
        <div class="installts">
            <div class="addpoper2"> 提现审核</div>
            <div class="dropdown">
                <div class="addpoper">
                    拒绝申请

                </div>

            </div>

        </div>

    </div>
    <div class="pmassage">

        <div class="userti">

            <div class="useheader">
                <img src="" alt="">
            </div>
            <div class="usetim">
                <div class="usename">
                    <div class="name">王小样</div>
                    <div class="huiy">普通会员</div>

                </div>
                <div class="usename" style="margin-left: 213px;">
                    <div class="tiixan">提现金额</div>
                    <div class="money">¥555.00</div>
                </div>
            </div>
        </div>

        <div class="monrymsg">


            <div class="monrymsgs">
                <div class="msgtop">银行卡信息</div>

                <ul>
                    <li>
                        <p>持卡人</p>
                        <p>城垣</p>
                    </li>

                    <li>
                        <p>银行卡账户</p>
                        <p>6222021505001500377</p>
                    </li>

                    <li>
                        <p>银行卡类型</p>
                        <p>储蓄卡</p>
                    </li>

                    <li>
                        <p>开户行账户</p>
                        <p>中国工商银行-储蓄卡</p>
                    </li>

                    <li>
                        <p>银行名称</p>
                        <p>中国工商银行</p>
                    </li>
                </ul>

            </div>

            <div class="monrymsgs">
                <div class="msgtop">基本信息</div>

                <ul>
                    <li>
                        <p>编号</p>
                        <p class="huise">12312412313</p>
                    </li>

                    <li>
                        <p>账户ID</p>
                        <p class="huise">12312412313</p>
                    </li>

                    <li>
                        <p>账户状态</p>
                        <p class="huise">正常使用</p>
                    </li>

                    <li>
                        <p>注册时间</p>
                        <p class="huise">2013-10-23 10:00:00</p>
                    </li>


                </ul>

            </div>
            <div class="monrymsgs">
                <div class="msgtop">其他信息</div>

                <ul>
                    <li>
                        <p>提现区域</p>
                        <p class="huise">江西省</p>
                    </li>

                    <li>
                        <p>申请时间</p>
                        <p class="huise">2012-02-13 24:12：23</p>
                    </li>

                    <li>
                        <p>提现单号</p>
                        <p class="huise">RF202312092134061353</p>
                    </li>

                    <li>
                        <p>是否加急</p>
                        <p class="huise">是</p>
                    </li>


                </ul>

            </div>
            <div class="monrymsgs">
                <div class="msgtop">审核信息</div>

                <ul>
                    <li>
                        <p>审核状态</p>
                        <p class="huise">审核中</p>
                    </li>

                    <li>
                        <p>审核时间</p>
                        <p class="huise">6222021505001500377</p>
                    </li>



                    <li>
                        <p>经办人</p>
                        <p class="huise">王芳</p>
                    </li>


                </ul>

            </div>
         

        </div>


    </div>
</template>

<script setup>

const goBack = () => {
    window.history.back();
}


</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
}

.installt {
    width: 100%;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .installts {
        display: flex;

        .dropdown {


            .addpoper {
                width: 120px;
                height: 52px;
                background: rgba(63, 140, 255);
                box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
                border-radius: 8px;
                color: #FFFFFF;
                text-align: center;
                line-height: 52px;



            }

        }





        .addpoper2 {
            width: 120px;
            height: 52px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;
            text-align: center;
            line-height: 52px;
            box-sizing: border-box;
            margin-right: 15px;
            cursor: pointer;

        }
    }

}

.pmassage {
    background-color: #fff;
    margin-top: 19px;
    height: calc(100% - 20px - 52px - 14px);
    border-radius: 8px;

    .userti {
        width: 100%;
        height: 130px;
        border-bottom: 1px solid #F5F5F5;
        display: flex;
        align-items: center;
        padding-left: 50px;
        box-sizing: border-box;

        .useheader {
            width: 46px;
            height: 46px;
            border-radius: 23px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .usetim {
            margin-left: 30px;
            height: 46px;

            display: flex;

            .usename {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .name {
                    font-size: 17px;
                    color: #111827;

                }

                .huiy {
                    font-weight: 600;
                    font-size: 15px;
                    color: #718096;

                }

                .tiixan {
                    font-weight: 500;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.88);
                }

                .money {
                    font-weight: 500;
                    font-size: 18px;
                    color: #FF4D4F;
                }



            }


        }
    }

    .monrymsg {
        padding: 32px 0 0 0px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;

        .monrymsgs {
            .msgtop {
                font-weight: 400;
                font-size: 18px;
                color: #0A1629;
                line-height: 25px;
            }

            ul {

                li {
                    margin-top: 32px;

                    p {
                        font-weight: 500;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.88);
                        line-height: 26px;

                    }

                    .huise {
                        color: #4D585F;
                    }
                }
            }

        }
    }
}
</style>